import { render, staticRenderFns } from "./AppSubmitButton.vue?vue&type=template&id=b0ecf1b0&scoped=true"
import script from "./AppSubmitButton.vue?vue&type=script&lang=ts"
export * from "./AppSubmitButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ecf1b0",
  null
  
)

export default component.exports